const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const h = React.createElement;
const DropshippingPlatformDetails = () => {
  const { api, t } = useSyncee();
  const resource = useResource(async () => ({ ...(await api.getPlatform()), ...(await api.getConnection()) }), [api]);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const action = async (callback, success) => { setBusy(true); setError(""); setMessage(""); try { await callback(); setMessage(success); await resource.reload(); } catch (requestError) { setError(requestError.message); } finally { setBusy(false); } };
  const platform = resource.data?.platform; const connection = resource.data?.connection;
  const details = platform ? h("div", { className: "synds-card" },
    h("div", { className: "synds-card-body" },
      h("div", { className: "synds-row synds-between" },
        h("h3", null, platform.name),
        h(StatusBadge, { status: connection?.status || "not_connected", t })
      ),
      h("p", { className: "synds-muted" }, `${t("h_syncee_store", "Store")}: ${connection?.storeName || connection?.externalStoreId || "—"}`),
      h("p", { className: "synds-muted" }, `${t("h_syncee_last_sync", "Last synchronization")}: ${connection?.lastSyncAt ? new Date(connection.lastSyncAt).toLocaleString() : "—"}`),
      h("div", { className: "synds-row" },
        h(LinkButton, { to: "/dropshipping/syncee/connect" }, t("h_syncee_connection", "Connection")),
        connection ? h(Button, { variant: "secondary", disabled: busy, onClick: () => action(api.testConnection, t("h_syncee_test_ok", "Connection test passed.")) }, t("h_syncee_test", "Test")) : null,
        connection?.status === "active" ? h(Button, { disabled: busy, onClick: () => action(api.syncAll, t("h_syncee_sync_ok", "Syncee synchronization completed.")) }, t("h_syncee_sync", "Synchronize")) : null
      )
    )
  ) : null;
  return h(React.Fragment, null,
    h(PageHeader, { title: t("h_syncee_details_title", "Syncee details") }),
    message ? h("div", { className: "synds-success", role: "status" }, message) : null,
    error ? h("div", { className: "synds-alert", role: "alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platform, reload: resource.reload, t }, details)
  );
};
module.exports = { DropshippingPlatformDetails };
